"use client";
import ScriptForm from "../../../global/view/new-script-form";

export default function PriceScriptForm() {
  return (
    <ScriptForm
      title="Price Script"
      showPatient={false}
      showPractitioner={false}
      initialPaymentType="Cash"
      paymentTypeReadOnly={true}
    />
  );
}
